import { Loader2 } from "lucide-react";

interface DetailsLoaderProps {
  title: string;
  subtitle: string;
}

/** Centered, friendly loading state used while ride/booking details are fetched. */
export function DetailsLoader({ title, subtitle }: DetailsLoaderProps) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="relative mb-6 flex h-24 w-24 items-center justify-center">
        <span className="absolute inset-0 animate-ping rounded-full bg-emerald-400/20" />
        <span className="absolute inset-2 rounded-full bg-emerald-100" />
        <Loader2 className="relative h-10 w-10 animate-spin text-emerald-600" />
      </div>
      <h2 className="text-xl font-bold text-foreground">{title}</h2>
      <p className="mt-2 max-w-sm text-sm text-muted-foreground">{subtitle}</p>
    </div>
  );
}
